<template>
  <TheLoader :active="true" v-if="loading"/>
  <div class="content-container flex-row" v-else>
    <section class="content white">
      <TheLoader :active="updating" style="opacity:0.5"/>
      <TheEmptyList v-if="items.length < 1" :title="'Ingen utleveringssedler'" :large="true" :icon="'glyph-medium-object'"/>

      <table v-if="items.length > 0" class="large fixed sortable clickable evenodd contracts table-filter">
        <thead>
          <tr>
            <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === queryParams.sort ? sortClass : '']" @click="changeSorting(heading.sortKey)">
              {{heading.name}}
              <span id="sorttable_sortrevind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'desc'">&nbsp;</span>
              <span id="sorttable_sortfwdind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'asc'">&nbsp;</span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in items" v-bind:key="item.Objektid">
            <td>
              <div class="flex-container">
                <span class="thumbnail-container">
                  <span class="thumbnail small">
                    <template v-if="objektThumb(item) && objektLarge(item)">
                      <img class="hi-trigger" :src="objektThumb(item)" :data-hi-src-full="objektLarge(item)" data-hi-size="large" />
                    </template>
                    <template v-else-if="objektThumb(item)">
                      <img :src="objektThumb(item)" />
                    </template>
                    <template v-else>
                      <span class="placeholder"></span>
                    </template>
                  </span>
                  <a href="javascript:;" class="primary-title">{{item.Objektnr}}</a>
                </span>
              </div>
            </td>

            <td class="show-for-large">
              {{item.title | truncate(40)}}
              <span class="opacity-60" v-if="item.subtitle"><br>{{item.subtitle | truncate(30)}}</span>
            </td>
            <td v-if="item.utleveringsseddel" class="show-for-large">
              {{item.utleveringsseddel.Bruker}}
            </td>
            <td v-else class="show-for-large">
            </td>
            <td class="show-for-large" v-if="item.kategori">
              {{item.Signature.Created | norwegiandate}}
            </td>
            <td>
              <a href="javascript:;" @click="downloadPdf(item.Objektid)" class="button action glyph glyph-only-small">
                <svg width="16px" height="16px" viewBox="0 0 16 16">
                  <use xlink:href="/static/sprites.svg#button-glyph-print"></use>
                </svg>
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-container"  v-if="pageCount > 1">
        <paginate v-model="currentPage"
          :page-count="pageCount"
          :page-range="11"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeCardShowTabObjektUtlev',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pdfSource: false,
      currentPage: 1, // Just for the pagination component
      headings: [
        {name: 'Objekt', sortKey: 'Objektnr', class: ''},
        {name: 'Tittel', sortKey: 'Tittel', class: 'show-for-large'},
        {name: 'Ansvarlig', sortKey: 'Ansvarlig', class: 'show-for-large'},
        {name: 'Dato', sortKey: 'Dato', class: 'show-for-large'}
      ],
      loadedImages: {}
    }
  },
  created () {
    // Note: The fetch of items is done in KundeCard.

    this.currentPage = this.queryParams.page || 1

    bus.$off('on-delivered-objects-done')
  },
  updated () {
    setTimeout(function () {
      // if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
      //   if (!window.jQuery('table.fixed').hasClass('sticky')) {
      //     window.jQuery('table.fixed').addClass('sticky')
      //     window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
      //     window.jQuery(window).resize(function () {})
      //   }
      // }

      // Tooltip
      if (window.jQuery('.has-tooltip') && window.jQuery('.has-tooltip').length > 0) {
        let $tooltip = window.jQuery('.tooltip')

        window.jQuery('.has-tooltip').unbind('hover')
        window.jQuery('.has-tooltip').hover(function () {
          let $tooltipData = window.jQuery(this).data('tootltip')

          if ($tooltipData) {
            $tooltipData = $tooltipData.substring(0, 10)
          } else {
            return
          }

          let $offsetTop = window.jQuery(this).offset().top
          let $offsetHeight = window.jQuery(this).height()
          let $offsetBottom = window.innerHeight - $offsetTop - $offsetHeight
          let $tooltipHeight = $tooltip.height() + 60

          $tooltip.html($tooltipData)

          // show tooltip if not already activeted
          if (!$tooltip.hasClass('active')) {
            $tooltip.addClass('active')

            window.jQuery(document).bind('mousemove', function (e) {
              $tooltip.css({
                left: e.pageX,
                top: e.pageY
              })

              if ($offsetBottom > $tooltipHeight) {
                $tooltip.css({
                  left: e.pageX - 90,
                  top: e.pageY + 40
                })
              } else {
                // offset the tooltip if to close to bottom
                $tooltip.css({
                  left: e.pageX - 90,
                  top: e.pageY - $tooltipHeight
                })
              }
            })
          }
        },
        // hide the tooltip on blur
        function () {
          $tooltip.removeClass('active')

          window.jQuery(document).unbind('mousemove', function (e) {})
        })
      }
    })
  },
  mounted () {
    bus.$on('on-delivered-objects-done', (data) => this.onDeliveredObjectsDone(data))

    setTimeout(function () {
      // if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
      //   if (!window.jQuery('table.fixed').hasClass('sticky')) {
      //     window.jQuery('table.fixed').addClass('sticky')
      //     window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
      //     window.jQuery(window).resize(function () {})
      //   }
      // }

      // Tooltip
      if (window.jQuery('.has-tooltip') && window.jQuery('.has-tooltip').length > 0) {
        let $tooltip = window.jQuery('.tooltip')

        window.jQuery('.has-tooltip').unbind('hover')
        window.jQuery('.has-tooltip').hover(function () {
          let $tooltipData = window.jQuery(this).data('tootltip')

          if ($tooltipData) {
            $tooltipData = $tooltipData.substring(0, 10)
          } else {
            return
          }

          let $offsetTop = window.jQuery(this).offset().top
          let $offsetHeight = window.jQuery(this).height()
          let $offsetBottom = window.innerHeight - $offsetTop - $offsetHeight
          let $tooltipHeight = $tooltip.height() + 60

          $tooltip.html($tooltipData)

          // show tooltip if not already activeted
          if (!$tooltip.hasClass('active')) {
            $tooltip.addClass('active')

            window.jQuery(document).bind('mousemove', function (e) {
              $tooltip.css({
                left: e.pageX,
                top: e.pageY
              })

              if ($offsetBottom > $tooltipHeight) {
                $tooltip.css({
                  left: e.pageX - 90,
                  top: e.pageY + 40
                })
              } else {
                // offset the tooltip if to close to bottom
                $tooltip.css({
                  left: e.pageX - 90,
                  top: e.pageY - $tooltipHeight
                })
              }
            })
          }
        },
        // hide the tooltip on blur
        function () {
          $tooltip.removeClass('active')

          window.jQuery(document).unbind('mousemove', function (e) {})
        })
      }
    })
  },
  computed: {
    ...mapGetters('kundeobjektsignature', [
      'items',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),
    sortClass: function () {
      return 'sorttable_sorted' + (this.queryParams.direction !== 'asc' ? '_reverse' : '')
    }
  },
  methods: {
    downloadPdf: function (Objektid) {
      this.openModal(
        'signed-objekt-modal',
        {
          kundenr: this.kunde.Kundenr,
          objektid: Objektid,
          internalWindow: true
        },
        'split'
      )
    },
    onDeliveredObjectsDone: function (data) {
      if (data.list) {
        // Also (re)load bought obj tab
        this.$store.dispatch('kundeobjektsignature/load', this.kunde.Kundenr)
      }
    },
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
    },
    objektLarge: function (item) {
      if (item.photos && item.photos.large && item.photos.large.length > 0) {
        return item.photos.large[0]
      }

      return null
    },
    objektThumbLoaded: function (item) {
      item.Fototatt = 'T'
    },
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = page
        copiedParams.page = vm.currentPage

        vm.$store.dispatch('kundeobjektsignature/reload', {
          kundenr: vm.kunde.Kundenr,
          queryParams: copiedParams
        })
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = 1
      copiedParams.page = this.currentPage

      if (copiedParams.sort === sortKey) {
        copiedParams.direction = copiedParams.direction === 'asc' ? 'desc' : 'asc'
      } else {
        copiedParams.direction = 'asc'
      }

      copiedParams.sort = sortKey

      this.$store.dispatch('kundeobjektsignature/reload', {
        kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShowTabUtleveringssedler.vue